import React, { FC, useContext } from 'react';
import { Styled } from './index.styles';
import { serverData } from '../../organisms/HotelInformation/HotelInformation';
import { useCheckBreakpoint } from '../../hooks';
import clsx from 'clsx';
import { useHQVContext } from '../../context';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HotelPetPolicy: FC<{ hotelInformationData: any }> = ({ hotelInformationData }) => {
  const { jsonContent } = useContext(serverData);
  const { hqvState } = useHQVContext();
  const policyInfo = hotelInformationData?.property?.policies;
  const petsAllowedFlag = policyInfo?.petsAllowed;
  const petsNotAllowedText = jsonContent?.petsNotAllowedLabel;
  const petsAllowedSearchText = jsonContent?.petsAllowedSearchText;
  const petsText = petsAllowedFlag ? petsAllowedSearchText : petsNotAllowedText;
  const petsPolicyDescription =
    policyInfo?.localizedPetsPolicyDescription?.translatedText ?? policyInfo?.petsPolicyDescription;
  const isViewportL = useCheckBreakpoint('viewportL');
  const isViewportM = useCheckBreakpoint('viewportM');

  return (
    <Styled>
      <div className="pet-policy">
        <div className={clsx('col', 'm-icon-text', 'section-heading', `${hqvState.modalOpenState ? 'hqv-modal' : ''}`)}>
          <span
            className={clsx(
              isViewportL ? 'icon-m' : 'icon-s',
              'check-out',
              'left-col-icon',
              'pet-policy-icon',
              'icon-pet-friendly',
              'icon-decorative'
            )}
          ></span>
          <span className={clsx(isViewportM ? 't-subtitle-l' : 't-subtitle-m', 'pet-policy-heading')}>
            {jsonContent?.petPolicyLabel}
          </span>
        </div>
        <div className={clsx(isViewportL ? 't-font-s' : 't-font-xs', 'pet-policy-information')}>{petsText}</div>
        {petsAllowedFlag && (
          <>
            {policyInfo?.petsPolicyDetails[0]?.maximumPetsDesc && (
              <div className={clsx(isViewportL ? 't-font-s' : 't-font-xs', 'pet-policy-sub-info')}>
                {policyInfo?.petsPolicyDetails?.maximumPetsDesc}
              </div>
            )}
            {petsPolicyDescription && (
              <div className={clsx(isViewportL ? 't-font-s' : 't-font-xs', 'pet-policy-sub-info')}>
                {petsPolicyDescription}
              </div>
            )}
            {policyInfo?.petsPolicyDetails[0]?.nonRefundableFee && (
              <div className={clsx(isViewportL ? 't-font-s' : 't-font-xs', 'pet-policy-sub-info')}>
                {jsonContent?.nonRefundableFeeLabel}: {policyInfo?.petsPolicyDetails[0]?.nonRefundableFee}{' '}
                {jsonContent?.perStayLabel}
              </div>
            )}
            {petsAllowedFlag && (
              <div className={clsx(isViewportL ? 't-font-s' : 't-font-xs', 'pet-policy-sub-info')}>
                {jsonContent?.contactHotelLabel}
              </div>
            )}
          </>
        )}
      </div>
    </Styled>
  );
};

export default HotelPetPolicy;
